import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saIntraCuHandoverCellChartConfig } from '../cellChartConfigs';

interface IntraCuHandoverSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const IntraCuHandoverSaCell: React.FC<IntraCuHandoverSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saIntraCuHandoverCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default IntraCuHandoverSaCell;
